export default __webpack_public_path__ + "static/media/basil_edit-outline.95efe708.svg";